import { render } from "./DAORequests.vue?vue&type=template&id=3f7f18f8&scoped=true"
import script from "./DAORequests.vue?vue&type=script&lang=js"
export * from "./DAORequests.vue?vue&type=script&lang=js"

import "./DAORequests.vue?vue&type=style&index=0&id=3f7f18f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7f18f8"]])

export default __exports__